export default "__VITE_ASSET__f5a83229__"